#import "./SentenceRecordingDetails.graphql"
query SentenceRecordingQuery($id: ID!) {
  sentenceRecording(id: $id) {
    ...sentenceRecordingDetails
  }
}
